(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"]) return;
  try {
    
const quizData = [
  { question: "Which habit helps you absorb iron better?", options: ["Drinking tea with meals", "Adding lemon to dal", "Using non-stick pans", "Skipping breakfast"], correct: 1, explanation: "Vitamin C (like lemon juice) boosts iron absorption. Tea, on the other hand, inhibits it." },
  { question: "Which has the most plant protein per 100g?", options: ["Chickpeas", "Tofu", "Soy chunks", "Quinoa"], correct: 2, explanation: "Soy chunks (Nutrela etc.) have over 50g protein per 100g dry — more than most meats." },
  { question: "Which of these flours is naturally gluten-free?", options: ["Wheat", "Barley", "Bajra", "Rye"], correct: 2, explanation: "Millets like bajra and jowar are gluten-free — good for gut-sensitive individuals." },
  { question: "True or False: Jaggery / khand are healthier than white sugar", options: ["False", "True"], correct: 0, explanation: "There’s barely any difference — both are sucrose with similar glycemic effects." },
  { question: "Which cooking oil is best suited for high-heat Indian cooking (e.g., tadka)?", options: ["Olive Oil", "Groundnut oil", "Sesame oil", "Mustard oil"], correct: 3, explanation: "Mustard oil has a high smoke point and is stable at high temperatures." },
  { question: "Which vitamin is most easily destroyed during cooking?", options: ["Vitamin A", "Vitamin C", "Vitamin D", "Vitamin E"], correct: 1, explanation: "Vitamin C is highly sensitive to heat and water - so preferably eat your amlas raw." },
  { question: "Eating which of these at night may interfere with sleep quality?", options: ["Banana", "Turmeric Milk", "Walnut", "Dark chocolate"], correct: 3, explanation: "Dark chocolate contains caffeine and theobromine — can disrupt sleep cycles." },
  { question: "Which of these statements is TRUE about gut health?", options: ["Gut health only affects digestion", "Gut bacteria is harmful", "Fermented foods help gut", "Idlis are probiotic"], correct: 2, explanation: "Fermented foods (that aren’t cooked post-fermentation) nourish gut bacteria." },
  { question: "What happens when you skip protein at breakfast?", options: ["You burn more fat", "You stay full longer", "You may overeat later", "No effect"], correct: 2, explanation: "Skipping protein leads to blood sugar swings and more cravings later." },
  { question: "Which among these is not a grain", options: ["Buckwheat", "Samak chawal / Barnyard Millet", "Rice", "Barley"], correct: 0, explanation: "Buckwheat is a seed (pseudocereal), not a true grain. It’s gluten-free." }
];

let current = 0, score = 0, timeLeft = 10, timer, userAnswers = [];

function showQuestion() {
  const q = quizData[current];
  const box = document.getElementById("quizBox");
  box.innerHTML = `
    <div class="quiz-question fade"><strong>Q${current + 1}:</strong> ${q.question}</div>
    <div class="timer">Time left: <span id="time">${timeLeft}</span>s</div>
    <div class="quiz-options">
      ${q.options.map((opt, i) => `<div class="option-card" data-index="${i}">${opt}</div>`).join("")}
    </div>
  `;

  updateProgress();
  fadeInElement(".quiz-question");

  timeLeft = 10;
  clearInterval(timer);
  timer = setInterval(() => {
    timeLeft--;
    document.getElementById("time").innerText = timeLeft;
    if (timeLeft === 0) {
      clearInterval(timer);
      userAnswers.push(null);
      nextQuestion();
    }
  }, 1000);

  document.querySelectorAll(".option-card").forEach(card => {
    card.addEventListener("click", (e) => {
      const selected = parseInt(e.target.getAttribute("data-index"));
      clearInterval(timer);
      selectOption(selected);
    });
  });
}

function updateProgress() {
  const percent = ((current) / quizData.length) * 100;
  document.getElementById("progressFill").style.width = `${percent}%`;
  document.getElementById("progressText").innerText = `Question ${current + 1} of ${quizData.length}`;
}

function selectOption(selected) {
  userAnswers.push(selected);
  if (selected === quizData[current].correct) score++;
  nextQuestion();
}

function nextQuestion() {
  current++;
  if (current < quizData.length) {
    showQuestion();
  } else {
    document.getElementById("progressFill").style.width = "100%";
    document.getElementById("progressText").innerText = `Question ${quizData.length} of ${quizData.length}`;
    showResult();
  }
}

function showResult() {
  document.getElementById("quizBox").style.display = "none";
  const resultBox = document.getElementById("resultBox");
  resultBox.style.display = "block";
  resultBox.scrollIntoView({ behavior: 'smooth' });

  if (score >= 8 && typeof confetti === 'function') confetti();

  const { badgeHigh, badgeMid, badgeLow, tipHigh, tipMid, tipLow, rewardHigh } = window.quizMeta;
  let badge = '', tip = '', reward = '';
  if (score >= 8) { badge = badgeHigh; tip = tipHigh; reward = rewardHigh; }
  else if (score >= 5) { badge = badgeMid; tip = tipMid; }
  else { badge = badgeLow; tip = tipLow; }

  let resultHTML = `
    <h3>You scored ${score} out of ${quizData.length}</h3>
    <div class="review-block" style="border-left: 4px solid #2e7d32; background: #f1f8f4;">
      <strong>Badge:</strong> ${badge}<br>
      <strong>Pro Tip:</strong> ${tip}<br>
      ${reward ? `<em>${reward}</em>` : ""}
    </div>
    <h4 style="margin-top:24px;">Review your answers:</h4>
  `;

  quizData.forEach((q, i) => {
    const userAnswer = userAnswers[i];
    const correct = q.correct;
    const isCorrect = userAnswer === correct;
    resultHTML += `
      <div class="review-block ${isCorrect ? 'correct' : 'wrong'}">
        <strong>Q${i + 1}:</strong> ${q.question}<br>
        <span style="color:${isCorrect ? 'green' : 'red'};">
          Your answer: ${userAnswer !== null ? q.options[userAnswer] : "<i>No answer</i>"}
        </span><br>
        <span style="color:green">Correct: ${q.options[correct]}</span>
        <em>${q.explanation}</em>
      </div>
    `;
  });

  resultHTML += `
   <div class="centered-retake">
      <button onclick="restartQuiz()" class="btn retake-btn">🔁 Retake Quiz</button>
    </div>
    <div class="result-buttons download-cta">
      <a href="https://play.google.com/store/apps/details?id=planit.club.planit" class="btn app-btn android">📱 Android App</a>
      <a href="https://apps.apple.com/in/app/planit-nutrition/id6740267648" class="btn app-btn ios">🍎 iOS App</a>
    </div>
  `;
  resultBox.innerHTML = resultHTML;
}

function restartQuiz() {
  current = 0;
  score = 0;
  timeLeft = 10;
  userAnswers = [];
  document.getElementById("resultBox").style.display = "none";
  document.getElementById("quizBox").style.display = "block";
  showQuestion();
}

function fadeInElement(selector) {
  const el = document.querySelector(selector);
  if (el) {
    el.classList.add('fade');
    setTimeout(() => el.classList.remove('fade'), 10);
  }
}

document.addEventListener("DOMContentLoaded", showQuestion);

  } catch(e) { console.error(e); }
})();
})();
